import React from "react";
import "../../assets/css/about.css";
export default function About(){
    return(
        <>
       <section className="journey-section">

  <h2 className="journey-title">Our Journey</h2>

  <div className="journey-card">
    <p>
      Established in 1999, Nishigandh Clinic & Hospital has been a pillar of healthcare in the region for over two decades. 
      What started as a small clinic has grown into a well-equipped hospital, serving thousands of patients with dedication and compassion.
    </p>
    <p>1999 मध्ये स्थापन झालेले Nishigandh Clinic and Hospital गेल्या दोन दशकांहून अधिक काळापासून परिसरातील आरोग्यसेवेचा एक विश्वासार्ह आधारस्तंभ आहे.

लहान क्लिनिकपासून सुरू झालेला हा प्रवास आज अत्याधुनिक सुविधांनी सुसज्ज रुग्णालयापर्यंत पोहोचला असून, हजारो रुग्णांना समर्पण आणि आपुलकीने सेवा दिली जात आहे.
</p>
  </div>

</section>

        <section className="mission-section">


  <div className="mission-split">

    <div className="mission-box mission-left">
      <h3>Our Mission</h3>
      <p>
        To provide affordable, accessible and high-quality healthcare services
        with compassion and commitment to every patient.
      </p>
    </div>

    <div className="mission-box vision-right">
      <h3>Our Vision</h3>
      <p>
        To become a trusted healthcare center known for excellence, innovation,
        and patient-centered care in the region.
      </p>
    </div>

  </div>

</section>
          <section className="mission-section">


  <div className="mission-split">

    <div className="mission-box mission-left">
      <h3>आमचे ध्येय</h3>
      <p>
        प्रत्येक रुग्णाला आपुलकी, समर्पण आणि विश्वासाने परवडणाऱ्या, सुलभ आणि उच्च दर्जाच्या आरोग्यसेवा प्रदान करणे.
      </p>
    </div>

    <div className="mission-box vision-right">
      <h3>आमची दृष्टी</h3>
      <p>
        उत्कृष्ट सेवा, आधुनिक वैद्यकीय सुविधा आणि रुग्णकेंद्रित उपचारांसाठी ओळखले जाणारे विश्वासार्ह आरोग्यसेवा केंद्र बनणे.
      </p>
    </div>

  </div>

</section>
      

        <section className="values-section ">

  <h2 className="values-title">Our Values</h2>

  <div className="values-list">

    <div className="values-item">
      <p>• Patient First Approach</p>
      <p>रुग्ण प्रथम सेवा दृष्टिकोन</p>
    </div>

    <div className="values-item">
      <p>• Integrity & Transparency</p>
      <p>प्रामाणिकपणा व पारदर्शकता</p>
    </div>

    <div className="values-item">
      <p>• Quality Treatment</p>
      <p>प्रामाणिकपणा व पारदर्शकता</p>
    </div>

    <div className="values-item">
      <p>• Compassionate Care</p>
      <p>सहानुभूतीपूर्ण रुग्ण सेवा</p>
    </div>

  </div>

</section>

<section className="tagline-section">

  <h2 className="tagline-title">Our Promise</h2>

  <div className="tagline-box">

    <p>“Care. Cure. Compassion.”</p>
    <p>“Your Health, Our Priority.”</p>
    <p>“Trusted Healthcare for a Better Tomorrow.”</p>
    <p>“Where Healing Begins with Care.”</p>

  </div>

</section>
<section className="tagline-section">

  <h2 className="tagline-title">आमचे वचन</h2>

  <div className="tagline-box">

    <p>““काळजी. उपचार. आपुलकी.”.”</p>
    <p>“तुमचे आरोग्य, आमची प्राथमिकता.”</p>
    <p>“उत्तम उद्यासाठी विश्वासार्ह आरोग्यसेवा.”</p>
    <p>“जिथे काळजीसोबत उपचाराची सुरुवात होते.”</p>

  </div>

</section>

<section className="about-highlight">

  <div className="highlight-grid">

    <div className="highlight-card">
      <div className="highlight-icon">🏥</div>
      <h4>Modern Facility</h4>
      <p>Advanced medical infrastructure with latest equipment.</p>
    </div>

    <div className="highlight-card">
      <div className="highlight-icon">👨‍⚕️</div>
      <h4>Expert Doctors</h4>
      <p>Experienced and highly skilled healthcare professionals.</p>
    </div>

    <div className="highlight-card">
      <div className="highlight-icon">⏱️</div>
      <h4>24/7 Service</h4>
      <p>Emergency care available anytime for patients.</p>
    </div>

    <div className="highlight-card">
      <div className="highlight-icon">❤️</div>
      <h4>Patient Care</h4>
      <p>Compassionate treatment with full attention.</p>
    </div>

  </div>

</section>
<section className="about-highlight">

  <div className="highlight-grid">

    <div className="highlight-card">
      <div className="highlight-icon">🏥</div>
      <h4>आधुनिक सुविधा</h4>
      <p>अत्याधुनिक उपकरणांसह प्रगत वैद्यकीय सुविधा उपलब्ध.</p>
    </div>

    <div className="highlight-card">
      <div className="highlight-icon">👨‍⚕️</div>
      <h4>तज्ज्ञ डॉक्टर</h4>
      <p>अनुभवी आणि उच्च कौशल्य असलेले आरोग्यसेवा तज्ज्ञ.</p>
    </div>

    <div className="highlight-card">
      <div className="highlight-icon">⏱️</div>
      <h4>२४x७ सेवा</h4>
      <p>रुग्णांसाठी आपत्कालीन सेवा कोणत्याही वेळी उपलब्ध.</p>
    </div>

    <div className="highlight-card">
      <div className="highlight-icon">❤️</div>
      <h4>रुग्ण सेवा</h4>
      <p>पूर्ण काळजी आणि आपुलकीने दिली जाणारी उपचार सेवा.</p>
    </div>

  </div>

</section>

        </>
    )
}